import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, ListGroup, ListGroupItem } from 'reactstrap';
import { Translate } from '../../helpers/Translate';

interface Club {
    value: string | number;
    label: string;
    description?: string;
}

interface ClubsModalProps {
    isOpen: boolean;
    toggle: () => void;
    clubs: Club[];
}

const ClubsModal: React.FC<ClubsModalProps> = ({ isOpen, toggle, clubs }) => {
    const [selectedClub, setSelectedClub] = useState<Club | null>(null);
    const t = new Translate();

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>{t.translate("Student Clubs")}</ModalHeader>
            <ModalBody>
                <div className="row">
                    <div className="col-md-4" style={{ borderRight: '1px solid #dee2e6', maxHeight: '400px', overflowY: 'auto' }}>
                        <h5>{t.translate("Select a Club")}</h5>
                        <select className='form-select' style={{height:'50px'}} onChange={(e:any)=>{
                            let value = e.target.value
                            const club :any = clubs?.find((club:any) => club.value == value);
                            console.log(club);
                            setSelectedClub(club);
                        }}>
                            <option value="">Select a club</option>
                            {clubs && clubs.map((club) => (
                                <option key={club.value} value={club.value}>
                                    {club.label}
                                </option>
                            ))}
                        </select>
                       
                    </div>
                    <div className="col-md-8 mt-3">
                        {selectedClub ? (
                            <div>
                                <h4>{selectedClub.label}</h4>
                                <hr />
                                <div className="mt-3">
                                    {selectedClub.description ? (
                                        <div dangerouslySetInnerHTML={{ __html: selectedClub.description }} />
                                    ) : (
                                        <p className="text-muted">{t.translate("No description available for this club.")}</p>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <div className="text-center mt-5">
                                <p className="text-muted">{t.translate("Please select a club to see its description.")}</p>
                            </div>
                        )}
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>{t.translate("Close")}</Button>
            </ModalFooter>
        </Modal>
    );
};

export default ClubsModal;
